import { useAuth } from "@/contexts/AuthContext";
import { usePasscodeStatus } from "@/hooks/usePasscode";
import { useState } from "react";
import { PasscodeSetupModal } from "@/components/PasscodeSetupModal";
import { Lock } from "lucide-react";

export function PasscodeSetupBanner() {
  const { role } = useAuth();
  const { data: status } = usePasscodeStatus();
  const [setupOpen, setSetupOpen] = useState(false);

  const isAdminOrAbove = role === "super_admin" || role === "admin";

  // Don't show if not admin/super_admin, or if passcode is already set, or loading
  if (!isAdminOrAbove || !status || status.hasPasscode) return null;

  return (
    <>
      <div className="bg-[hsl(var(--warning)/0.15)] border-l-4 border-[hsl(var(--warning))] rounded-r-lg p-3 mb-4 flex items-center gap-3">
        <Lock className="h-4 w-4 text-[hsl(var(--warning))] shrink-0" />
        <p className="text-sm flex-1">
          <span className="font-medium">Your security passcode is not set up yet.</span>{" "}
          Some actions require a passcode to protect your nursery's data.
        </p>
        <button
          onClick={() => setSetupOpen(true)}
          className="text-sm font-medium text-primary hover:underline whitespace-nowrap"
        >
          Set up passcode →
        </button>
      </div>
      <PasscodeSetupModal open={setupOpen} onOpenChange={setSetupOpen} />
    </>
  );
}
